"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventConfigurationPageHotelPanes;
(function (EventConfigurationPageHotelPanes) {
    EventConfigurationPageHotelPanes[EventConfigurationPageHotelPanes["VendorAccess"] = 1] = "VendorAccess";
    EventConfigurationPageHotelPanes[EventConfigurationPageHotelPanes["LodgingOptions"] = 2] = "LodgingOptions";
    EventConfigurationPageHotelPanes[EventConfigurationPageHotelPanes["TermsAndConditions"] = 3] = "TermsAndConditions";
})(EventConfigurationPageHotelPanes || (EventConfigurationPageHotelPanes = {}));
exports.default = EventConfigurationPageHotelPanes;
